import React from 'react';
import { formatCredits } from '../../utils/credits';

const PriceBreakdown = ({ user, amountToSubtract }) => {
    return (
        <div className="d-flex justify-content-between align-items-baseline w-100 gap-4">
            <div className="credits d-flex justify-content-start gap-3 flex-grow-1">
                <div className="text-start">
                    <div className="text-white text-opacity-50 text-uppercase">
                        Current credits
                    </div>
                    <div className="text-uppercase">Payment</div>
                    <div className="text-uppercase text-primary">Remaining credits</div>
                </div>
                <div className="text-end">
                    <div className="text-white text-opacity-50">
                        <span className="fas fa-fw me-2" />
                        {formatCredits(user.parentOrganization.creditAmount)}
                    </div>

                    <div>
                        <span className="fas fa-minus fa-fw me-2 text-danger" />
                        <span className="text-end">{formatCredits(amountToSubtract)}</span>
                    </div>

                    <div className="text-primary">
                        <span className="fas fa-fw me-2" />
                        <span className="fw-bold text-end">
                            {formatCredits(user.parentOrganization.creditAmount - amountToSubtract)}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PriceBreakdown;
